import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import './index.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="NYO-China"
      meta={[
        { name: 'description', content: 'The National Youth Orchestra of China (NYO-China) provides exceptional Chinese student musicians access to superior instruction, extraordinary performance opportunities, and a platform upon which they could represent their country and their generation to the world.' },
        { name: 'keywords', content: 'sample, something' },
      ]}
    />
    <div>
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js